import { useFrame } from '@react-three/fiber';
import { useRef, useState } from 'react';
import { Fog } from 'three';

function MovingFog() {
	const fogRef = useRef<Fog>(null);
	const [time, setTime] = useState(0);

	useFrame((state, delta) => {
		setTime((prev) => prev + delta);
		if (fogRef.current) {
			// subtle movement
			fogRef.current.near = 100 + Math.sin(time) * 2;
			fogRef.current.far = 300 + Math.cos(time) * 5;
		}
	});

	// Match the fog color to the scene background to avoid tinting
	return <fog ref={fogRef} attach="fog" args={['#22262a', 100, 1000]} />;
}

export default MovingFog;
